import React, { useState } from "react";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import { colors } from "../constants/colors";
import SeriesSliderItem from "./SeriesSliderItem";

export default function SeriesSlider(props) {
  const [items, setItems] = useState(null);
  const [selectedSeries, setSelectedSeries] = useState(null); // Track the selected series

  React.useEffect(() => {
    // Don't filter items based on SeriesCodes filter, just set them directly
    setItems(props.items);
  }, [props.items]);

  const handleClick = (series) => {
    // Deselect the currently selected series
    if (selectedSeries !== null) {
      // Trigger a re-fetch from the backend here if needed.
      // For now, we are not handling backend re-fetch directly.
    }

    // Select the new series
    setSelectedSeries(series);

    // Call the parent component's onClick function
    props.onClick(series);
  };

  let seriesDataSelectedSeriesCode = null;
  if (props.seriesDataSelectedSeries != null) {
    seriesDataSelectedSeriesCode = props.seriesDataSelectedSeries.code;
  }

  return (
    <>
      <Carousel
        focusOnSelect={false}
        responsive={responsive}
        customRightArrow={<CustomArrow isLeft={false} />}
        customLeftArrow={<CustomArrow isLeft={true} />}
        containerClass="c-series c-series__series-slider"
        transitionDuration={300}
        partialVisible={items?.length > 5 ? true : false}
      >
        {items?.length > 0 &&
          items
            .filter((x) => x.articleCount > 0)
            .map((series) => {
              return (
                <SeriesSliderItem
                  key={series.code}
                  filterGroups={props.filterGroups}
                  onClick={handleClick} // Use the new handleClick function
                  series={series}
                  showHideSeriesData={(series) => props.showHideSeriesData(series)}
                  seriesDataBtnActive={seriesDataSelectedSeriesCode === series.code && props.showInlineSeriesData === true ? true : false}
                />
              );
            })}
      </Carousel>
    </>
  );
}

const CustomArrow = ({ onClick, isLeft, ...rest }) => {
  const {
    onMove,
    carouselState: { currentSlide, deviceType },
  } = rest;

  return (
    <button
      onClick={() => onClick()}
      style={{
        ...arrowStyle,
        padding: isLeft ? "8px 7px 8px 5px" : "8px 5px 8px 7px",
        left: isLeft ? "0" : "auto",
        right: isLeft ? "auto" : "0",
      }}
    >
      <i className={isLeft ? "icon-chevron-left" : "icon-chevron-right"} />
    </button>
  );
};

const responsive = {
  superLargeDesktop: {
    breakpoint: { max: 4000, min: 3000 },
    items: 5,
  },
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 5,
    partialVisibilityGutter: 15,
    slidesToSlide: 5,
  },
  tablet: {
    breakpoint: { max: 1024, min: 464 },
    items: 2,
    partialVisibilityGutter: 15,
    slidesToSlide: 2,
  },
  mobile: {
    breakpoint: { max: 564, min: 0 },
    items: 1,
    partialVisibilityGutter: 15,
    slidesToSlide: 1,
  },
};

const arrowStyle = {
  border: 0,
  position: "absolute",
  fontSize: "130%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  backgroundColor: colors.cejnBlue,
  color: colors.white,
};
